import {
    Dispatch,
    FC,
    ReactNode,
    SetStateAction,
} from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import { HybridMap } from '../HybridMap';
import { GOOGLE_MAPS_KEY, MAPBOX_ACCESS_TOKEN } from '../../const/environments.constants';

interface DriversMapProps {
    children: ReactNode;
    setMapsLoaded: Dispatch<SetStateAction<boolean>>;
    center: {
        lat: number;
        lng: number;
    };
    zoom: number;
    bounds?: [number, number, number, number] | null;
}

const DriversMap: FC<DriversMapProps> = ({
    children,
    setMapsLoaded,
    center,
    zoom,
    bounds,
}) => (
    <div style={{ width: '100%', height: '100%' }}>
        <HybridMap
            apiKeys={{ mapbox: MAPBOX_ACCESS_TOKEN as string, google: GOOGLE_MAPS_KEY }}
            center={center}
            zoom={zoom}
            bounds={bounds}
            setMapsLoaded={setMapsLoaded}
            persistKey="fleets-drivers"
        >
            {children}
        </HybridMap>
    </div>
);

export { DriversMap };
